module.exports = __webpack_public_path__ + "img/6.3c096de6.png";